"use client";
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    BookOpen: function() {
        return BookOpen;
    },
    default: function() {
        return _default;
    }
});
const _jsxruntime = require("react/jsx-runtime");
const _utils = require("@mui/material/utils");
const BookOpen = (0, _utils.createSvgIcon)(/*#__PURE__*/ (0, _jsxruntime.jsx)("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/ (0, _jsxruntime.jsx)("path", {
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M3 6.25457V18.1858C4.20526 17.5869 5.56391 17.25 7 17.25C8.43609 17.25 9.79474 17.5869 11 18.1858V6.25457C9.8662 5.46348 8.48833 5 7 5C5.51167 5 4.1338 5.46348 3 6.25457ZM13 6.25457V18.1858C14.2053 17.5869 15.5639 17.25 17 17.25C18.4361 17.25 19.7947 17.5869 21 18.1858V6.25457C19.8662 5.46348 18.4883 5 17 5C15.5117 5 14.1338 5.46348 13 6.25457ZM12 4.51569C10.5698 3.55859 8.8491 3 7 3C4.87259 3 2.91514 3.73938 1.37453 4.97438C1.13777 5.16417 1 5.45119 1 5.75463V20.0046C1 20.3892 1.22055 20.7397 1.56726 20.9061C1.91397 21.0726 2.3254 21.0254 2.62547 20.7849C3.82406 19.8241 5.34362 19.25 7 19.25C8.65638 19.25 10.1759 19.8241 11.3745 20.7849C11.74 21.0779 12.26 21.0779 12.6255 20.7849C13.8241 19.8241 15.3436 19.25 17 19.25C18.6564 19.25 20.1759 19.8241 21.3745 20.7849C21.6746 21.0254 22.086 21.0726 22.4327 20.9061C22.7795 20.7397 23 20.3892 23 20.0046V5.75463C23 5.45119 22.8622 5.16417 22.6255 4.97438C21.0849 3.73938 19.1274 3 17 3C15.1509 3 13.4302 3.55859 12 4.51569Z",
        fill: "currentColor"
    })
}), "BookOpen");
const _default = BookOpen;
